import { Box, Typography } from "@mui/material";
import styles from "../StructuredPromptImageCanvas.module.scss";

interface ObjectBboxProps {
	bbox: { left: number; top: number; width: number; height: number };
	name: string;
	state: "hover" | "selected";
	onClick?: (e: React.MouseEvent) => void;
	onMouseDown?: (e: React.MouseEvent) => void;
	onMouseOver?: () => void;
	onMouseLeave?: () => void;
}

export const ObjectBbox = ({ bbox, name, state, onClick, onMouseDown, onMouseOver, onMouseLeave }: ObjectBboxProps) => {
	const { left, top, width, height } = bbox;
	const isSelected = state === "selected";

	// Both states: position above bbox, spanning full width
	// Using top + translateY(-100%) to position label's bottom edge at bbox's top edge
	const labelStyle = {
		left: `${left}px`,
		top: `${top}px`,
		width: `${width}px`,
	};

	return (
		<>
			<Box
				className={isSelected ? styles.bboxSelected : styles.bboxHover}
				style={{
					left: `${left}px`,
					top: `${top}px`,
					width: `${width}px`,
					height: `${height}px`,
				}}
				onClick={onClick}
				onMouseDown={onMouseDown}
				onMouseOver={onMouseOver}
				onMouseLeave={onMouseLeave}
			/>
			<Typography className={isSelected ? styles.labelExpanded : styles.label} style={labelStyle}>
				{name}
			</Typography>
		</>
	);
};
